<div class="modal-detail">
    <div class="modal-header">
        <h2>Completed Interviews</h2>
        <span class="dismiss" (click)="closeModal()"><i class="far fa-times-circle"></i></span>
    </div>
    <div class="modal-body">
        <div class="table-container">
            <table class="table table-striped table-fixed">
                <tbody>
                    <tr *ngFor="let a of applicants" class="applicant" (click)="openApplicant(a)">
                        <td>
                            <app-round-image class="profile-image" [url]="a.profile" [useDefaultMissingImage]="true" [width]="30" [height]="30"></app-round-image> {{a.name}}
                            <span *ngIf="a.status > 0" container="body" ngbPopover="{{a.statusInfo}}" popoverClass="slot-popover"
                                triggers="mouseenter:mouseleave" popoverTitle="Note"><i class="warning fa-solid fa-circle-exclamation"></i></span>
                        </td>
                        <td class="state">{{a.userState}}</td>
                    </tr> 
                </tbody>
            </table>
        </div>
        <div class="buttons">
            <button type="button" class="btn btn-success btn-wide" (click)="closeModal()">OK</button>
        </div>
    </div>
</div>